var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16697 8.05209C6.1659 8.03487 6.16537 8.0175 6.16537 8V1.33333C6.16537 0.873096 6.53846 0.5 6.9987 0.5C7.45894 0.5 7.83203 0.873096 7.83203 1.33333V8C7.83203 8.00197 7.83202 8.00393 7.83201 8.0059L9.83203 6.5C10.2002 6.22386 10.7226 6.29848 10.9987 6.66667C11.2748 7.03486 11.2002 7.55719 10.832 7.83333L7.4987 10.3333C7.35445 10.4415 7.17901 10.5 6.9987 10.5C6.82593 10.5013 6.65703 10.4489 6.51536 10.35L3.18203 8C2.80802 7.73468 2.71864 7.21704 2.98203 6.84167C3.10959 6.65963 3.3046 6.5361 3.52369 6.49854C3.74277 6.46098 3.96779 6.51251 4.1487 6.64167L6.16697 8.05209ZM1.16536 14.6667C0.733892 14.6667 0.379009 14.3387 0.336334 13.9185C0.333489 13.8905 0.332031 13.8621 0.332031 13.8333V12.1667C0.332031 11.7064 0.705127 11.3333 1.16536 11.3333C1.6256 11.3333 1.9987 11.7064 1.9987 12.1667V13H11.9987V12.1667C11.9987 11.7064 12.3718 11.3333 12.832 11.3333C13.2923 11.3333 13.6654 11.7064 13.6654 12.1667V13.8333C13.6654 14.2936 13.2923 14.6667 12.832 14.6667H1.16536Z",
    fill: "#212B36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.01b2b0444f62bd2c5ef7061b67678dfa.svg";
export { ForwardRef as ReactComponent };